export default "__VITE_ASSET__Bh1_DK8c__"